import { memo } from "react";

import SingleLegalDocument from "./SingleLegalDocument";

function DataProcessingAgreement() {
   return <SingleLegalDocument document="dataProcessingAgreement" />;
}

export default memo(DataProcessingAgreement);
